import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	anchorMenu: {
		background: theme.palette.background.light,
		opacity: 0,
		transform: "translate(0, -100%)",
		transition: "none"
	},
	animate: {
		opacity: 1,
		transform: "translate(0, 0)",
		transition: "all 300ms ease-in 300ms"
	},
	container: {
		display: "flex",
		flexWrap: "nowrap",
		gap: theme.spacing(4),
		overflow: "auto",
		paddingBottom: "7px !important",
		paddingTop: "7px !important",
		"&::-webkit-scrollbar": {
			height: 2
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: theme.palette?.grey?.[200]
		},
		[theme.breakpoints.up("md")]: {
			gap: theme.spacing(6)
		}
	},
	item: {
		position: "relative",
		"&::before": {
			background: theme.palette?.grey?.[200],
			content: "''",
			height: 16,
			position: "absolute",
			right: -16,
			top: "50%",
			transform: "translate(0, -50%)",
			width: 1
		},
		"&:last-child::before": {
			display: "none"
		},
		[theme.breakpoints.up("md")]: {
			"&::before": {
				right: -24
			}
		}
	},
	label: {
		color: theme.palette?.grey?.[800],
		display: "block",
		padding: theme.spacing(1, 0),
		transition: "color 300ms ease",
		whiteSpace: "nowrap",
		"&:hover": {
			color: theme.palette.primary.main
		}
	}
}));

export default styles;
